import PropTypes from 'prop-types';
import React from 'react';
import CountryCodePhoneInputRedux from '../countryCodePhoneInputRedux';

const PhoneFormField = ({ disabled, name, label, placeholder, formatter }) => (
  <div className="layout__item u-1/2-medium-and-up">
    <div className="c-label-new">{ label }</div>
    <CountryCodePhoneInputRedux
      disabled={disabled}
      name={name}
      className="c-input fs-mask"
      placeholder={placeholder}
      formatter={formatter}
    />
  </div>
  );

PhoneFormField.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  formatter: PropTypes.func,
};

PhoneFormField.defaultProps = {
  disabled: false,
  label: '',
  placeholder: '',
  formatter: phone => phone,
};

export default PhoneFormField;
